import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

/*
  The previous version of this file set inline styles on <body> and wrapped the
  app in a styled <div>. Both are now handled by the stylesheet layer
  (src/styles/base.css), which keeps layout out of JavaScript and means the
  page is correctly styled before React hydrates rather than after.
*/

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error(
    'Root element #root was not found. Check the markup in public/index.html.'
  );
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
